export default { aui: 'aui', iau: 'iau', iua: 'iua' };
